/* WAKALIT - Sugar Dust (azúcar glas cayendo) */
(function () {
  // Evita duplicados
  if (document.getElementById("wakalit-sugar-dust")) return;

  const canvas = document.createElement("canvas");
  canvas.id = "wakalit-sugar-dust";
  document.body.appendChild(canvas);

  const ctx = canvas.getContext("2d");
  let w, h;
  let particles = [];
  const particleCount = 55; // cantidad (sube/baja si quieres)

  function resize() {
    w = canvas.width = window.innerWidth;
    h = canvas.height = window.innerHeight;
  }

  function random(min, max) {
    return Math.random() * (max - min) + min;
  }

  function createParticles() {
    particles = [];
    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: random(0, w),
        y: random(-h, h),
        r: random(0.6, 1.6),      // tamaño mini
        s: random(0.3, 1.05),     // velocidad
        a: random(0.15, 0.40),    // transparencia
        drift: random(-0.25, 0.25) // movimiento lateral suave
      });
    }
  }

  function draw() {
    ctx.clearRect(0, 0, w, h);

    for (const p of particles) {
      ctx.beginPath();
      ctx.fillStyle = `rgba(255,255,255,${p.a})`;
      ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
      ctx.fill();

      p.y += p.s;
      p.x += p.drift;

      // Reinicio cuando baja
      if (p.y > h + 10) {
        p.y = -10;
        p.x = random(0, w);
      }

      // Si se va de lado, vuelve
      if (p.x < -10) p.x = w + 10;
      if (p.x > w + 10) p.x = -10;
    }

    requestAnimationFrame(draw);
  }

  // Ajustes iniciales
  resize();
  createParticles();
  draw();

  // Responsive
  window.addEventListener("resize", function () {
    resize();
    createParticles();
  });
})();
